import { render } from "./RegistrationTicketList.vue?vue&type=template&id=c50b9af8"
import script from "./RegistrationTicketList.vue?vue&type=script&lang=js"
export * from "./RegistrationTicketList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__